<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">待盖章</el-menu-item>
		  <el-menu-item index="list2">已盖章</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
		  <bSeal v-if="activeIndex == 'list'"></bSeal>
		  <cSeal v-if="activeIndex == 'list2'"></cSeal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import bSeal from "./bSeal.vue";//待盖章
import cSeal from "./cSeal.vue";//已盖章
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
    };
  },
  components: {
	bSeal,cSeal,
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath) {
		console.log(key, keyPath)
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
  },
};
</script>